export const HOTJAR_ID = 5240667;
export const GOOGLE_ANALYTICS = "G-J4W91HKYYX";

export const DROOMWORK_TALENT_REF_ID = "droomwork-tm-01"; // 'droomxgLK0u445'

/* Access token (or, for pre-migration sessions, the legacy no-expiry JWT). */
export const TOKEN = "droomwork-talent-token";
/* Opaque refresh token. Absent for sessions that started via the legacy
   ?token= handoff; the refresh manager treats "no refresh token" as
   "session over", which is what keeps the legacy path working. */
export const REFRESH_TOKEN = "droomwork-talent-refresh";
/* Access-token expiry as epoch ms, so we can refresh pre-emptively later
   without decoding the JWT on every request. */
export const ACCESS_TOKEN_EXPIRY = "droomwork-talent-token-exp";
